(function () {
  var main = document.querySelector('main[data-template]');
  if (!main || main.dataset.template !== 'index') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var heading = document.querySelector('.banner__heading');
  if (!heading) return;

  var rawText = heading.textContent.trim();
  if (!rawText) return;

  var cs = getComputedStyle(heading);
  var text = cs.textTransform === 'uppercase' ? rawText.toUpperCase() : rawText;
  var fontWeight = cs.fontWeight || '700';
  var fontFamily = cs.fontFamily || 'sans-serif';
  var color = cs.color || '#ffffff';

  var srText = document.createElement('span');
  srText.textContent = rawText;
  srText.style.position = 'absolute';
  srText.style.width = '1px';
  srText.style.height = '1px';
  srText.style.overflow = 'hidden';
  srText.style.clip = 'rect(0, 0, 0, 0)';
  srText.style.whiteSpace = 'nowrap';

  var canvas = document.createElement('canvas');
  canvas.setAttribute('aria-hidden', 'true');
  canvas.style.display = 'inline-block';
  canvas.style.maxWidth = '100%';

  heading.textContent = '';
  heading.appendChild(srText);
  heading.appendChild(canvas);

  var ctx = canvas.getContext('2d');
  var offscreen = document.createElement('canvas');
  var offCtx = offscreen.getContext('2d');

  var FUZZ_RANGE = 12;
  var BASE_INTENSITY = 0.15;
  var HOVER_INTENSITY = 0.45;
  var hovering = false;
  var dpr = Math.min(window.devicePixelRatio || 1, 2);

  function getFontSizePx() {
    return parseFloat(getComputedStyle(heading).fontSize) || 40;
  }

  function build() {
    var fontSizePx = getFontSizePx();
    var fontString = fontWeight + ' ' + fontSizePx + 'px ' + fontFamily;
    offCtx.font = fontString;
    var metrics = offCtx.measureText(text);
    var width = Math.ceil(metrics.width) + FUZZ_RANGE * 2;
    var ascent = metrics.actualBoundingBoxAscent || fontSizePx * 0.85;
    var descent = metrics.actualBoundingBoxDescent || fontSizePx * 0.2;
    var height = Math.ceil(ascent + descent) + 4;

    offscreen.width = width;
    offscreen.height = height;
    offCtx.font = fontString;
    offCtx.textBaseline = 'alphabetic';
    offCtx.fillStyle = color;
    offCtx.clearRect(0, 0, width, height);
    offCtx.fillText(text, FUZZ_RANGE, ascent + 2);

    canvas.width = width * dpr;
    canvas.height = height * dpr;
    canvas.style.width = width + 'px';
    canvas.style.height = height + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function draw() {
    ctx.clearRect(0, 0, offscreen.width, offscreen.height);
    var intensity = hovering ? HOVER_INTENSITY : BASE_INTENSITY;
    var h = offscreen.height;
    for (var j = 0; j < h; j++) {
      var dx = Math.round((Math.random() - 0.5) * FUZZ_RANGE * intensity * 2);
      ctx.drawImage(offscreen, 0, j, offscreen.width, 1, dx, j, offscreen.width, 1);
    }
    requestAnimationFrame(draw);
  }

  build();
  window.addEventListener('resize', build);
  heading.addEventListener('mouseenter', function () {
    hovering = true;
  });
  heading.addEventListener('mouseleave', function () {
    hovering = false;
  });
  requestAnimationFrame(draw);
})();
